<template>
  <div class="card p-2" style="min-height: 200px">
    <div class="table-responsive">
      <table class="table">
        <thead>
        <tr>
          <th>Employee Name</th>
          <th>Leave Type</th>
          <th>From Date</th>
          <th>To Date</th>
          <th>Applied For(Days)</th>
          <th>Leave Balance</th>
          <th>Purpose</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in tableItems" :key="i">
          <td>{{ item.employee_name }}</td>
          <td>{{ item.leave_policies_name }}</td>
          <td>{{ item.start_date }}</td>
          <td>{{ item.end_date }}</td>
          <td>{{ item.number_of_days }}</td>
          <td>{{ item.remaining_leave_balance }}</td>
          <td>{{ item.purpose }}</td>
          <td>{{ item.status }}</td>
          <td>
            <button class="btn btn-primary btn-sm mx-1"
                    @click="viewDetails(item)"
                    style="cursor: pointer"
            >
              <i class="fas fa-eye"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
      <p v-if="tableItems.length < 0" class="text-center mt-5">No data</p>
    </div>

    <LeaveApplicationDetailsModal
        v-if="store.state.isModalOpenTwo"
        :leaveApplicationLogData="leaveApplicationLogData"
      />

  </div>
</template>

<script setup>
import {useRoute, useRouter} from "vue-router";
import LeaveApplicationDetailsModal from '@/components/molecule/company/hrm-payroll/leave-application/LeaveApplicationDetailsModal.vue';
import {computed, inject, ref} from "vue";
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import {useStore} from "vuex";

const props  = defineProps({
  tableItems     : Object,
});
const route  = useRoute();
const router = useRouter();
const isEdit = ref(false)
const showError = inject('showError');
const showSuccess = inject('showSuccess')
const editData = ref(false)
const loading = ref(false)
const store = useStore()
const leaveApplicationLogData = ref({})
const companyId = computed(() => {
  return route.params.companyId
})

const {
  fetchSingleLeaveApplication
} = handleHrPayroll()

function getQuery() {
  return `?company_id=${route.params.companyId}`;
}

const viewDetails = (item) => {
   store.state.isModalOpenTwo = true;
  const fetchSingleData = fetchSingleLeaveApplication(item.id, getQuery());
  fetchSingleData.then(res => {
    if (res.status){
       leaveApplicationLogData.value = res.data.leave_application_logs
    }
  });
}

</script>
